import moment from "moment";

import Badge from "@/components/design-system/badge";
import type { BadgeSize } from "@/components/design-system/badge/badge";
import WarningIcon from "public/next-public/common/icons/warning-icon.svg";

/**
 * "Expires Feb 2027", for an offer whose product carries an expiration date. The backend sends the date as
 * MM/YYYY, so the tooltip names the month. An unreadable date shows no badge.
 */
function ExpiresBadge({ expiration, size = "small", namesProduct = false }: ExpiresBadgeProps) {
  const date = moment(expiration, "MM/YYYY", true);
  if (!date.isValid()) {
    return null;
  }
  const iconSize = size === "small" ? 12 : 16;

  return (
    <Badge
      label={`${namesProduct ? "Product Expires" : "Expires"} ${date.format("MMM YYYY")}`}
      color="red"
      size={size}
      icon={<WarningIcon width={iconSize} height={iconSize} aria-hidden />}
      tooltip={`This product expires in ${date.format("MMMM YYYY")}.`}
      tooltipPlacement="below"
    />
  );
}

export default ExpiresBadge;

interface ExpiresBadgeProps {
  /** MM/YYYY */
  expiration: string;
  size?: BadgeSize;
  /** "Product Expires Feb 2027", for the badge on a seller the shopper has picked. */
  namesProduct?: boolean;
}
